class KenMaterialTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.ken-material-tabs__button'));
    this.panels = Array.from(this.querySelectorAll('.ken-material-tabs__panel'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.activate(button));
    });
  }

  activate(activeButton) {
    const targetId = activeButton.dataset.target;

    this.buttons.forEach((button) => {
      button.classList.toggle('active', button === activeButton);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('active', panel.id === targetId);
    });
  }
}

customElements.define('ken-material-tabs', KenMaterialTabs);
